import { useState } from 'react';

/**
 * @typedef {Array} UseToggleReturn
 * @property {boolean} toggleValue UseToggleReturn[0] - the current true or false value
 * @property {function:void} toggler UseToggleReturn[1] - a function to run to toggle the true or false value
 */

/**
 * Tracks a toggling of true and false state.
 *
 * @param {boolean} initialState the initial true or false state
 * @returns {UseToggleReturn}
 *
 * @example
 * const [toggleValue, toggler] = useToggle(false);
 */
const useToggle = (initialState) => {
  const [toggleValue, setToggleValue] = useState(initialState);

  const toggler = () => {
    setToggleValue(!toggleValue)
  };

  return [toggleValue, toggler];
};

export default useToggle;

